<template>
  <div>
    <!-- 抽屉 -->
    <el-drawer
      :append-to-body="true"
      class="drawer"
      title="请选择权按钮"
      :visible.sync="drawerShow"
      :before-close="handleClose">
      <div class="container">
        <el-row class="screen" :span="24">
          <el-col :span="16">
            <el-input placeholder="请输入按钮名称" v-model.trim="buttonName" @keyup.13.native="drawerHandlerKeyUp" class="inp"  >
              <el-button slot="append" icon="el-icon-search" @click="drawerDemand"></el-button>
            </el-input>
          </el-col>
        </el-row>
         <el-table
          ref="multipleTable"
          :data="versionTableData"
          :row-key="getRowKeys"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="{background:'#eef1f6',color:'#606266'}"
          @select='onTableSelect'
          @select-all="handleAllChange"
          @selection-change="handleSelectionChange">
          <el-table-column
          :reserve-selection="true"
            type="selection">
          </el-table-column>
          <el-table-column
            prop="buttonId"
            label="id"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="buttonName"
            label="按钮名称"
            >
          </el-table-column>
        </el-table>
         <!-- 分页管理 -->
        <el-row
          v-show="!listLoading"
          class="pagination-container"
          type="flex" justify="end"
          >
          <!-- 页码按钮的数量currenCurrent  sizeChange -->
          <el-pagination
            :current-page.sync="listQuery.page"
            :page-size="listQuery.limit"
            :total="total"
            layout="total,prev, pager, next"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"/>
        </el-row>
      </div>
      <div class="drawer-footer">
      <div class="drawer-btn">
          <el-button
          type="primary"
          @click="confirm"
          >
            确定
          </el-button>
          <el-button @click="cancel" >取消</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { btnsList } from '@/api/buttons' //
export default {
  props: {
    drawerFlag: {
      type: Boolean,
      default: false
    },
    btnId: {
      type: Number
    },
    accessData: {
      type: Array
    }
  },
  data () {
    return {
      // 分页功能
      total: 0, // 到时候从后台获取
      listLoading: false, // 根据loading来进行显示/隐藏
      listQuery: {
        page: 1,
        limit: 10
      },
      drawerShow: false,
      buttonName: '', // 按钮名称
      versionTableData: [],
      multipleSelection: [], // 选择框选的数量
      keysArr: [],
      accessIds: []
    }
  },
  created () {
    console.log(this.accessData)
    this.drawerShow = this.drawerFlag
    this.getRoleList()
  },
  mounted () {
  },
  methods: {
    // 获取权限列表
    getRoleList () {
      this.keysArr = this.accessData.map(v => v.buttonId)
      const params = {
        buttonName: this.buttonName,
        pageNumber: this.listQuery.page,
        pageSize: this.listQuery.limit
      }
      btnsList(params).then((res) => {
        const resData = res.data.data
        console.log(resData)
        this.versionTableData = resData.list
        if (resData.total <= 5) this.listLoading = true
        this.total = resData.total
        this.$nextTick(() => {
          if (this.versionTableData.length && this.versionTableData.length > 0) {
            this.versionTableData.forEach(row => {
              if (this.keysArr.includes(row.buttonId)) {
                this.$refs.multipleTable.toggleRowSelection(row, true)
              }
            })
          }
        })
      })
    },
    handleClose (done) {
      this.$confirm('确认关闭？', '提示', {
        closeOnClickModal: false
      })
        .then(_ => {
          this.$emit('closeDrawer')
        })
        .catch(_ => {})
        .finally(_ => {
          // this.$parent.focusStatus = true
        })
    },
    // 抽屉搜索功能
    drawerHandlerKeyUp (e) {
      if (e.keyCode === 13) {
        this.drawerDemand()
      }
    },
    // 搜索
    drawerDemand () {
      this.getRoleList()
    },
    // 分页管理
    handleSizeChange (val) {
      this.listQuery.limit = val
      this.getRoleList()
    },
    // 改变页码
    handleCurrentChange (val) {
      this.listQuery.page = val
      this.getRoleList()
    },
    getRowKeys (row) {
      return row.buttonId // id为列表数据的唯一标识
    },
    handleAllChange (selecteds) {
      // selecteds length > 0 则是全选,为空则为反选
      if (selecteds.length === 0) {
        console.log('selecteds', selecteds)
        console.log('multipleSelection', this.multipleSelection)
        this.versionTableData.forEach(item => {
          this.keysArr.forEach((id, index) => {
            if (id === item.buttonId) {
              this.keysArr.splice(index, 1)
            }
          })
        })
      } else {
        this.multipleSelection.forEach(item => {
          if (!this.keysArr.includes(item.buttonId)) {
            this.keysArr.push(item.buttonId)
          }
        })
      }
    },
    onTableSelect (rows, row) {
      console.log(row)
      const selected = rows.length && rows.indexOf(row) !== -1 // true就是选中，0或者false是取消选中
      if (!selected) { // 为false时将id截取出来
        for (let index = 0; index < this.keysArr.length; index++) {
          if (this.keysArr[index] === row.buttonId) {
            this.keysArr.splice(index, 1)
          }
        }
      }
    },
    // table栏val选择的时间
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    confirm () {
      console.log('keysArr', this.keysArr)
      console.log('multipleSelection', this.multipleSelection)
      const sendData = []
      this.multipleSelection.forEach((ele) => {
        sendData.push({
          buttonId: ele.buttonId,
          buttonName: ele.buttonName
        })
      })
      const keysData = []
      this.keysArr.forEach((res) => {
        this.accessData.map((ele) => {
          if (ele.buttonId === res) {
            keysData.push({
              buttonId: ele.buttonId,
              buttonName: ele.buttonName
            })
          }
        })
      })
      const arr = sendData.concat(keysData)
      console.log(arr)
      const result = []
      var obj = {}
      for (var i = 0; i < arr.length; i++) {
        if (!obj[arr[i].buttonId]) {
          result.push(arr[i])
          obj[arr[i].buttonId] = true
        }
      }
      console.log(result)
      this.$emit('getData', result)
    },
    cancel () {
      this.handleClose()
    }
  }
}
</script>

<style lang='less' scoped>
.drawer{
    /deep/ .el-drawer__header{
      line-height: 60px !important;
      font-size: 18px !important;
      height: 60px !important;
      border-bottom: 1px solid #efefef !important;
      padding: 0 24px !important;
      margin-bottom: 0 !important;
    }
    /deep/ .el-drawer__body{
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: space-between;
      .container{
        margin-bottom: 64px;
        padding: 16px 24px 0 24px !important;
        border-top: 1px solid #ececec;
        .screen{
          display: flex;
          margin-bottom: 20px;
          /deep/ .el-input{
            margin-left: 0;
            width: 90%;
          }
        }
        /deep/ .el-table::before{
          background: white;
        }
        /deep/ .el-table th>.cell:first-child{
          padding: 0 14px
        }
        /* .cell:first-child{

        } */
      }
      .drawer-footer{
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid #ececec;
        margin-top: 10px;
        padding: 0 24px ;
        height:64px;
        i{
          color: #409eff;
          font-style: normal;
        }
      }
    }
    /deep/ :focus {
      outline: 0;
    }
  }
</style>
